import * as React from "react";
import { Field } from "formik";
import DateTimePicker from "views/components/time-range-picker/DateTimePicker";
const AbsoluteCalendar = ({ startDate = void 0, timeRange, range }) => /* @__PURE__ */ React.createElement(Field, { name: `timeRangeTabs.absolute.${range}` }, ({ field: { value, onChange, name }, meta: { error } }) => {
  const _onChange = (newValue) => onChange({ target: { name, value: newValue } });
  const dateTime = error ? timeRange[range] : value || timeRange[range];
  return /* @__PURE__ */ React.createElement(DateTimePicker, { error, onChange: _onChange, value: dateTime, range, startDate });
});
export default AbsoluteCalendar;
